module.exports = __webpack_public_path__ + "static/media/leaf2.27b359bb.jpeg";